'use client';

import cn from 'classnames';
import Image from 'next/image';
import { Separator } from '@/shared/ui/core';
import { useEffect, useRef, useState } from 'react';
import { Alert0, Alert1, Alert2, Alert3, Alert4, Alert5 } from '../../assets/alerts';
import styles from './alerts-slides.module.scss';


export function AlertsSlides () {
    const rootRef                 = useRef<HTMLDivElement>(null);
    const [ visible, setVisible ] = useState(false);

    useEffect(() => {
        const node = rootRef.current;
        if (!node) return;

        const observer = new IntersectionObserver(
            ([ entry ]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.3 },
        );

        observer.observe(node);

        return () => observer.disconnect();
    }, []);


    return (
        <div
            ref={ rootRef }
            className={ cn(styles.root, { [styles.visible]: visible }) }
        >
            <Image
                width={ 735 }
                height={ 298 }
                src={ Alert0 }
                alt="Alert frame"
                className={ styles.slide }
            />

            <div className={ styles.slide }>
                <Image
                    width={ 695 }
                    height={ 20 }
                    src={ Alert1 }
                    alt="Alert frame"
                />
                <Separator orientation="horizontal"/>
            </div>

            <div className={ styles.slide }>
                <Image
                    width={ 695 }
                    height={ 20 }
                    src={ Alert2 }
                    alt="Alert frame"
                />
                <Separator orientation="horizontal"/>
            </div>

            <div className={ styles.slide }>
                <Image
                    width={ 695 }
                    height={ 20 }
                    src={ Alert3 }
                    alt="Alert frame"
                />
                <Separator orientation="horizontal"/>
            </div>

            <div className={ styles.slide }>
                <Image
                    width={ 695 }
                    height={ 20 }
                    src={ Alert4 }
                    alt="Alert frame"
                />
                <Separator orientation="horizontal"/>
            </div>

            <div className={ styles.slide }>
                <Image
                    width={ 695 }
                    height={ 20 }
                    src={ Alert5 }
                    alt="Alert frame"
                />
                <Separator orientation="horizontal"/>
            </div>
        </div>
    );
}
